import React, { Component } from "react";
import AudioPlayer, { RHAP_UI } from "react-h5-audio-player";
import clsx from "clsx";
import { FileType } from "../../laco-common/base/models/IFile";
import ImageView from "../ui/Media/ImageView";
import { EMPTY_IMG } from "../../models/Image";
import { getContainerWidth, MOBILE_RES_BREAKPOINT } from "../../models/layout";
import { IEditableWidget } from "../../models/cms";
import "react-h5-audio-player/lib/styles.css";
import "./AudioPlayer.scss";

type AudioPlayerProps = { url: string; thumbUrl?: string; title?: string; subHeading?: string } & IEditableWidget & {
		cmsField?: string;
		omitHeader?: boolean;
		displayEmpty?: boolean;
		miniPlayer?: boolean;
	};

class SiteAudioPlayer extends Component<AudioPlayerProps> {
	renderHeader() {
		if (this.props.omitHeader) return null;
		const editable: boolean = !!this.props.editWidget;
		let imageSize: number = 177;
		const containerWidth: number = getContainerWidth();
		if (containerWidth < MOBILE_RES_BREAKPOINT) {
			imageSize = containerWidth - 90;
		}

		return (
			<>
				<h2
					contentEditable={editable}
					className={clsx(editable && "cms-editable-field")}
					data-cms-field={`${this.props.cmsField}.title`}
					onBlur={this.props.onInput}
				>
					{(this.props.title || "").trim()}
				</h2>
				<h4
					contentEditable={editable}
					className={clsx("text-gray text-uppercase mb-1 mt-2", editable && "cms-editable-field")}
					data-cms-field={`${this.props.cmsField}.subHeading`}
					onBlur={this.props.onInput}
				>
					{(this.props.subHeading || "").trim()}
				</h4>
				<ImageView
					className="audio-thumb"
					viewWidth={imageSize}
					viewHeight={imageSize}
					image={{
						thumbUrl: this.props.thumbUrl || EMPTY_IMG,
						url: this.props.thumbUrl || EMPTY_IMG,
						fileType: FileType.IMAGE,
						filename: "",
						title: this.props.title,
					}}
				/>
			</>
		);
	}

	render() {
		return (
			<div
				className={clsx(
					"audio-container",
					this.props.displayEmpty && "show-empty-audio",
					this.props.miniPlayer && "mini-player"
				)}
			>
				{this.props.displayEmpty && <i className="im im-play"></i>}
				{!this.props.displayEmpty && (
					<>
						<AudioPlayer
							// autoPlay
							src={this.props.url}
							onPlay={(e) => console.log("onPlay")}
							showSkipControls={!this.props.miniPlayer}
							header={this.renderHeader()}
							layout="stacked-reverse"
							customIcons={
								{
									//   play?: ReactNode
									//   pause?: ReactNode
									//   rewind?: ReactNode
									//   forward?: ReactNode
									//   previous?: ReactNode
									//   next?: ReactNode
									//   loop?: ReactNode
									//   loopOff?: ReactNode
									//   volume?: ReactNode
									//   volumeMute?: ReactNode
								}
							}
							customControlsSection={
								this.props.miniPlayer
									? [RHAP_UI.MAIN_CONTROLS]
									: [RHAP_UI.MAIN_CONTROLS, RHAP_UI.ADDITIONAL_CONTROLS, RHAP_UI.VOLUME_CONTROLS]
							}
						/>
						{/* {this.props.children} */}
					</>
				)}
			</div>
		);
	}
}

export default SiteAudioPlayer;

// links to players:
/* https://www.npmjs.com/package/react-h5-audio-player */
// https://static.hanzluo.com/react-h5-audio-player-storybook/index.html?path=/docs/layouts--default-story

// Customize audio player: http://alexkatz.me/posts/building-a-custom-html5-audio-player-with-javascript/
// https://github.com/CookPete/react-player

/* <video controls>
					<source
						// src="https://firebasestorage.googleapis.com/v0/b/la-county-fire-dep.appspot.com/o/site%2Faudio%2Ffirewives%2Ffile_example_MP3_700KB.mp3?alt=media&amp;token=db7b0329-10e1-4fbb-819a-7aa1c60fdb60"

						src={this.props.url}
						type="audio/mpeg"
					/>
				</video>
				<ReactPlayer url={this.props.url} /> */
